(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
    // Get the page title
    var pageTitle = "{{ page_title }}";

    // Function to hide blog posts with matching titles
    function hideMatchingPosts() {
        $('.article-card__heading').each(function() {
            var title = $(this).text().trim(); // Get the text content of the title
            if (title === pageTitle) {
                // If the title matches the page title, hide the corresponding blog post
                $(this).closest('.blog__post').hide();
            }
        });
    }
    
    // Call the function to hide matching posts
    hideMatchingPosts();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rambo-banner-alt"] && !window.DesignMode) return;
  try {
    
// Add your scripts here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rambo-banner"] && !window.DesignMode) return;
  try {
    
// Add your scripts here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rambo-video-grid"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll(".youtube-thumbnail, .play-button");

  videos.forEach(video => {
    video.addEventListener("click", function() {
      const videoId = this.getAttribute("data-video-id");
      if (typeof $.fancybox !== 'undefined') {
        $.fancybox.open({
          src: `https://www.youtube.com/embed/${videoId}?autoplay=1`,
          type: 'iframe',
          opts : {
            iframe : {
              preload : false
            }
          }
        });
      } else {
        console.error("Fancybox is not defined.");
      }
    });
  });

  // Fetch and display video titles
  const videoContainers = document.querySelectorAll(".youtube-grid-item");
  videoContainers.forEach(container => {
    const videoId = container.querySelector('.youtube-thumbnail').getAttribute("data-video-id");
    const titleElement = container.querySelector('.video-title');
    fetchVideoTitle(videoId)
      .then(title => {
        titleElement.innerText = title;
      })
      .catch(error => {
        console.error("Error fetching video title:", error);
      });
  });

  async function fetchVideoTitle(videoId) {
    const response = await fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=AIzaSyDbMKcoTEQ2y8or0nsc7jRdDMcYhRPo4N0`);
    const data = await response.json();
    if (data.items.length > 0) {
      return data.items[0].snippet.title;
    } else {
      throw new Error("Video not found or API key invalid");
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
